import { Dispatch, SetStateAction, useState } from 'react'
import { Switch } from '../../../../../elements'
import { useWebchatV2 } from '../../../../../hooks'
import { WebchatV1Form } from './WebchatV1Form'
import { WebchatV2Form } from './WebchatV2Form'

export type WebchatFormProps = {
  data: Record<string, any>
  setData: Dispatch<SetStateAction<Record<string, any>>>
  readonly?: boolean
  webhookUrl?: string
  workspaceId: string
}
export function WebchatForm({ botId, ...props }: WebchatFormProps & { workspaceId: string; botId: string }) {
  const { setIsWebchatV2Enabled, isWebchatV2Enabled } = useWebchatV2()
  const [isDirty, setIsDirty] = useState<boolean>(false)

  return (
    <>
      {
        <div className="mb-4 flex items-center justify-between rounded-lg border border-gray-1 bg-gray-1 px-4 py-2 text-sm">
          <div className=" text-gray-11">
            <p>Switch to the new webchat for a better experience</p>
            {isDirty && (
              <p className="mb-0 mt-1 text-xs text-gray-11">
                You need to update the script on your website for the change to take effect.{' '}
              </p>
            )}
          </div>

          <div className="items-center">
            <Switch
              checked={isWebchatV2Enabled}
              color="emerald"
              label={isWebchatV2Enabled ? 'Using new' : 'Using classic'}
              labelClassName="text-gray-11"
              onCheckedChange={(value) => {
                setIsDirty(true)
                setIsWebchatV2Enabled(value)
              }}
            />
          </div>
        </div>
      }
      {isWebchatV2Enabled ? <WebchatV2Form {...props} /> : <WebchatV1Form {...{ botId }} {...props} />}
    </>
  )
}
